import { formatFieldName } from "./formatters";

export const isEmpty = (str) => {
  if (!str) {
    return true;
  }

  if (str && !str.trim()) {
    return true;
  }

  return false;
};

export const requiredValidationHelper = (values, errors, fields) => {
  fields.forEach((field) => {
    if (!values[field] || !values[field].trim()) {
      errors[field] = getRequiredMessage(field);
    }
  });
};

export const isValidPhone = (str) => {
  if (!str) {
    return false;
  }

  const regex = /^\+\d{11,11}$/;

  return regex.test(str);
};

export const getRequiredMessage = field => {
  return `${formatFieldName(field)} is required`
}
export const requiredMsg = 'This field is required';
export const invalidPhoneMsg = 'Invalid phone number. Ex.: +19991234567';
